import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { SearchIcon, MapPinIcon } from 'lucide-react';
type KeywordCardProps = {
  keyword: string;
};
const KeywordCard: React.FC<KeywordCardProps> = ({
  keyword
}) => <>
    <div className="flex items-center justify-between p-3 sm:p-4 rounded-xl bg-slate-50 border border-slate-200 shadow-sm" data-id="element-238">
      <div className="flex items-center gap-2 sm:gap-3 min-w-0" data-id="element-239">
        <SearchIcon className="w-4 h-4 sm:w-5 sm:h-5 text-slate-400 shrink-0" data-id="element-240" />
        <span className="text-slate-900 font-medium text-sm sm:text-lg truncate" data-id="element-241">
          {keyword}
        </span>
      </div>
      <span className="px-2 sm:px-3 py-0.5 sm:py-1 rounded-full bg-gold-500/15 text-gold-600 text-[10px] sm:text-xs font-bold uppercase tracking-wider shrink-0 ml-2" data-id="element-242">
        High Intent
      </span>
    </div>
  </>;
export function LocalSEO() {
  return <>
      <SlideLayout data-id="element-243">
        <div className="mb-6 sm:mb-10" data-id="element-244">
          <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-245" />
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-246">
            Local SEO Opportunity
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 sm:gap-12 items-center" data-id="element-247">
          {/* Left Content */}
          <div className="w-full lg:w-3/5 space-y-4 sm:space-y-8" data-id="element-248">
            <p className="text-sm sm:text-xl text-slate-600 leading-relaxed" data-id="element-249">
              Location-specific pages are critical for capturing local search
              traffic. Homebuyers and homeowners actively search for mortgage
              services using location-specific terms — and without dedicated
              location pages, you're missing out on this high-intent traffic
              entirely.
            </p>

            <div className="space-y-2 sm:space-y-3" data-id="element-250">
              <KeywordCard keyword="mortgage broker Victoria" data-id="element-251" />
              <KeywordCard keyword="first time mortgages Edmonton" data-id="element-252" />
              <KeywordCard keyword="refinancing mortgage Calgary" data-id="element-253" />
              <KeywordCard keyword="best mortgage rates + city" data-id="element-254" />
              <KeywordCard keyword="reverse mortgage + city" data-id="element-255" />
            </div>

            <div className="p-4 sm:p-6 rounded-xl bg-gold-500/10 border border-gold-500/20" data-id="element-256">
              <p className="text-gold-600 font-bold text-sm sm:text-lg" data-id="element-257">
                Build location-targeted landing pages (e.g., First Time
                Mortgages in Victoria, Refinancing in Edmonton) to capture
                region-specific search traffic and outrank local competitors.
              </p>
            </div>
          </div>

          {/* Right Visual — Abstract Map */}
          <div className="w-full lg:w-2/5 flex justify-center items-center relative h-[250px] sm:h-[400px] hidden sm:flex" data-id="element-258">
            {/* Abstract Map Rings */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-259">
              <div className="w-[200px] sm:w-[300px] h-[200px] sm:h-[300px] rounded-full border border-slate-200 absolute animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite]" data-id="element-260" />
              <div className="w-[130px] sm:w-[200px] h-[130px] sm:h-[200px] rounded-full border border-slate-300 absolute" data-id="element-261" />
              <div className="w-[70px] sm:w-[100px] h-[70px] sm:h-[100px] rounded-full border border-slate-300 absolute bg-slate-100/50 backdrop-blur-sm" data-id="element-262" />

              {/* Center Pin */}
              <div className="relative z-10 w-10 h-10 sm:w-12 sm:h-12 bg-gold-500 rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(128,80,235,0.2)]" data-id="element-263">
                <MapPinIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-264" />
              </div>
            </div>

            {/* Floating Labels */}
            <div className="absolute top-1/4 left-1/4 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg bg-white/80 backdrop-blur-md border border-slate-200 text-xs sm:text-sm font-medium text-slate-900 shadow-sm" data-id="element-265">
              Victoria
            </div>
            <div className="absolute bottom-1/3 right-1/4 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg bg-white/60 backdrop-blur-md border border-slate-200 text-[10px] sm:text-xs font-medium text-slate-600 shadow-sm" data-id="element-266">
              Edmonton
            </div>
            <div className="absolute top-1/3 right-1/4 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg bg-white/60 backdrop-blur-md border border-slate-200 text-[10px] sm:text-xs font-medium text-slate-600 shadow-sm" data-id="element-267">
              Calgary
            </div>
            <div className="absolute bottom-1/4 left-1/3 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg bg-white/60 backdrop-blur-md border border-slate-200 text-[10px] sm:text-xs font-medium text-slate-600 shadow-sm" data-id="element-268">
              Vancouver
            </div>
          </div>
        </div>
      </SlideLayout>
    </>;
}